export const DRAFT_STORAGE_PREFIX = 'barometro_draft_';
